export const ACADEMIC_YEAR = '/academicyear/'
export const ACADEMIC_YEAR_ACTIVATE = `${ACADEMIC_YEAR}activate/`
export const ACADEMIC_YEAR_ALL = `${ACADEMIC_YEAR}all`
